<template src="./../templates/Pagination.html" />

<script setup>
/* eslint-disable no-unused-vars, no-cond-assign, no-param-reassign */

import { pagination } from '../data/pagination.js';
import { setResults, isLoading } from '../data/results.js';
import { routing } from '../data/routing.js';
import { config } from '../config/config.js';

function loadNextPage() {

    pagination.offset += config.limit;

    setResults();

    routing.updateURLFromFilters();

}

</script>
